import React from "react";

export default function Hero({ totalSausages, guessesCount, maxGuesses }) {
  return (
    <header className="hero-card glass-card">
      <div className="hero-copy">
        <div className="eyebrow">korvdle.se - Skapad av LuffarLeif</div>
        <h1>Gissa dagens korv</h1>
        <p>
          En svensk, stilren och daglig gissningslek där du jagar rätt korv genom ledtrådar om land,
          kött, rökighet, kryddighet, servering och struktur.
        </p>
      </div>

      <div className="hero-stats">

        <div className="hero-stat-box">
          <span>Korvbibliotek</span>
          <strong>{totalSausages}</strong>
          <small>korvar i demon</small>
        </div>

        <div className="hero-stat-box">
          <span>Dagens runda</span>
          <strong>{guessesCount}/{maxGuesses}</strong>
          <small>försök använda</small>
        </div>
      </div>
    </header>
  );
}
